// extracted by mini-css-extract-plugin
module.exports = {"btn__task":"TasksPage_btn__task__OBDpM"};